import { Languages } from "src/common/descriptions/types";
import { PayableContractPaymentsDescriptions } from "./types";

const DescriptionsEnUs: PayableContractPaymentsDescriptions = {
    TITLE: "Payable Payments Records",
    TABLE: {
        ACTION_BUTTON: "Get Records",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Datetime",
        DESCRIPTION: "Description",
        TOTAL: "Total Payed",
        CASH: "Cash",
        TRANSACTION: "Transaction",
        DISSCOUNT: "Disscount",
        ACTIONS: "Actions",
        RECEIPT: "Receipt",
    },
}

const DescriptionsEsUs: PayableContractPaymentsDescriptions = {
    TITLE: "Pagos a Proveedores",
    TABLE: {
        ACTION_BUTTON: "Ver Registros",
        SEARCH_PLACEHOLDER: "Buscar",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Fecha",
        DESCRIPTION: "Descripción",
        TOTAL: "Total Pagado",
        CASH: "Efectivo",
        TRANSACTION: "Transacción",
        DISSCOUNT: "Descuento",
        ACTIONS: "Acciones",
        RECEIPT: "Comprobante",
    },
}

export const payableContractPaymentsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
